var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-3" }, [
      _c("div", { staticClass: "form-group center" }, [
        _c("div", { staticClass: "form-label" }, [
          _c("label", { class: _vm.normalFlag ? "required" : "" }, [
            _vm._v("税率(%)")
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _vm.normalFlag
              ? _c(
                  "el-select",
                  {
                    attrs: { filterable: "", placeholder: "请选择税率" },
                    on: {
                      change: function($event) {
                        _vm.taxRateChange(_vm.contract.taxRate)
                      }
                    },
                    model: {
                      value: _vm.contract.taxRate,
                      callback: function($$v) {
                        _vm.$set(_vm.contract, "taxRate", $$v)
                      },
                      expression: "contract.taxRate"
                    }
                  },
                  _vm._l(_vm.fiscalTaxMarkList, function(item) {
                    return _c("el-option", {
                      key: item.rate,
                      attrs: { label: item.rate, value: item.rate }
                    })
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.normalFlag
              ? _c("el-input", {
                  staticClass: "width-2x",
                  on: {
                    change: function($event) {
                      _vm.taxRateChange(_vm.contract.taxRate)
                    }
                  },
                  model: {
                    value: _vm.contract.taxRate,
                    callback: function($$v) {
                      _vm.$set(_vm.contract, "taxRate", $$v)
                    },
                    expression: "contract.taxRate"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _c("el-checkbox", {
              on: {
                change: function($event) {
                  _vm.bizAreaFlagChange(null)
                }
              },
              model: {
                value: _vm.contract.bizAreaFlag,
                callback: function($$v) {
                  _vm.$set(_vm.contract, "bizAreaFlag", $$v)
                },
                expression: "contract.bizAreaFlag"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.contract.typeId == _vm.goodsPurch.value
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(2),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.contract.settleAutoFlag,
                      callback: function($$v) {
                        _vm.$set(_vm.contract, "settleAutoFlag", $$v)
                      },
                      expression: "contract.settleAutoFlag"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: true } }, [_vm._v("是")]),
                    _vm._v(" "),
                    _c("el-radio", { attrs: { label: false } }, [_vm._v("否")])
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.contract.typeId == _vm.goodsPurch.value && _vm.contract.settleAutoFlag
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c("el-input-number", {
                  attrs: { controls: false, min: 1, max: 28 },
                  model: {
                    value: _vm.contract.settlePeriodDay,
                    callback: function($$v) {
                      _vm.$set(_vm.contract, "settlePeriodDay", $$v)
                    },
                    expression: "contract.settlePeriodDay"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("发票信息")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "swb-btn swb-btn-link",
          on: { click: _vm.selectInvoiceSubject }
        },
        [_vm._v("常用发票")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-form flex col-2" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-2x" }, [
          _c(
            "ul",
            { staticClass: "enum-list" },
            _vm._l(_vm.invoiceTypeList, function(merchantInvoiceType) {
              return _c(
                "li",
                {
                  staticClass: "enum-item",
                  class: {
                    checked:
                      merchantInvoiceType.value == _vm.contract.invoiceType
                  },
                  on: {
                    click: function($event) {
                      _vm.checkInvoiceType(merchantInvoiceType.value)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(merchantInvoiceType.text)
                  ),
                  _c("i")
                ]
              )
            })
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _c("el-input", {
              model: {
                value: _vm.contract.invoiceTitle,
                callback: function($$v) {
                  _vm.$set(_vm.contract, "invoiceTitle", $$v)
                },
                expression: "contract.invoiceTitle"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value width-2x mt5" }, [
          _c(
            "ul",
            { staticClass: "enum-list" },
            _vm._l(_vm.invoiceContentTagList, function(invoiceContentTag) {
              return _c(
                "li",
                {
                  staticClass: "enum-item",
                  class: {
                    checked:
                      invoiceContentTag.name == _vm.contract.invoiceContentTag
                  },
                  on: {
                    click: function($event) {
                      _vm.checkinvoiceContentTag(invoiceContentTag.name)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(invoiceContentTag.name)
                  ),
                  _c("i")
                ]
              )
            })
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(7),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value width-2x" },
          [
            _c("el-input", {
              model: {
                value: _vm.contract.taxPayerNo,
                callback: function($$v) {
                  _vm.$set(_vm.contract, "taxPayerNo", $$v)
                },
                expression: "contract.taxPayerNo"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(8),
    _vm._v(" "),
    _c("div", { staticClass: "simple-row" }, [
      _c("div", { staticClass: "left" }, [
        !_vm.showAssetInfo
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: { click: _vm.showMkuListDlg }
              },
              [_c("span", [_vm._v("选择商品")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showAssetInfo
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: { click: _vm.showDevcDefListDlg }
              },
              [_c("span", [_vm._v("选择资产定义")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showAssetInfo
          ? _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: { click: _vm.showAsmblAccListDlg }
              },
              [_c("span", [_vm._v("选择组装件定义")])]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c(
          "button",
          {
            staticClass: "swb-btn swb-btn-small swb-btn-primary",
            on: {
              click: function($event) {
                _vm.setBizFormBatch()
              }
            }
          },
          [_vm._v("批量设置经营业态")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-form",
          { ref: "contractGoodsList", attrs: { model: _vm.contract } },
          [
            !_vm.showAssetInfo
              ? _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.contract.contractGoodsList,
                      border: "",
                      "tooltip-effect": "dark",
                      maxHeight: "500"
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        width: "40",
                        align: "center",
                        fixed: "left"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "left", prop: "name", label: "商品名称" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "left", prop: "catName", label: "分类" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "100px",
                        prop: "brandName",
                        label: "品牌"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "left", prop: "model", label: "型号" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "left", prop: "fixedSpec", label: "规格" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "60",
                        prop: "asmblAccFlag",
                        label: "组装件"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "contractGoodsList." +
                                      scope.$index +
                                      ".asmblAccFlag"
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: scope.row.asmblAccFlag,
                                        expression: "scope.row.asmblAccFlag"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        scope.row.asmblAccFlag
                                      )
                                        ? _vm._i(scope.row.asmblAccFlag, null) >
                                          -1
                                        : scope.row.asmblAccFlag
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = scope.row.asmblAccFlag,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  scope.row,
                                                  "asmblAccFlag",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  scope.row,
                                                  "asmblAccFlag",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              scope.row,
                                              "asmblAccFlag",
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          _vm.setAsmblAcc(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      ]
                                    }
                                  })
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "190",
                        prop: "asmblAccFlag",
                        label: "关联定义"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.assetDefId != null &&
                              scope.row.assetDefId != -1
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "ellipsis",
                                      staticStyle: {
                                        "padding-right": "5px",
                                        display: "inline-block",
                                        width: "95%",
                                        "line-height": "1"
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.assetDefNo))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.assetDefId == null ||
                              scope.row.assetDefId == -1
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.selectDevcDef(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("选择")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.skuId > 0 &&
                              (scope.row.assetDefId == null ||
                                scope.row.assetDefId == -1)
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.saveDevcDef(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("生成定义")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  staticStyle: {
                                    position: "absolute",
                                    right: "2px"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.clearDevcDef(
                                        scope.row,
                                        scope.$index,
                                        true
                                      )
                                    }
                                  }
                                },
                                [_vm._v("清除")]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.contract.kindId == 0
                      ? _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "80px",
                            prop: "quantity",
                            label: "数量"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "contractGoodsList." +
                                          scope.$index +
                                          ".quantity"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: 6,
                                          disabled: scope.row.bizAreaFlag,
                                          type: "text"
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.goodsAmountOrQuantityChange(
                                              scope.row,
                                              scope.$index,
                                              "quantity"
                                            )
                                          }
                                        },
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "quantity",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "scope.row.quantity"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "100",
                        label: "是否可定制"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: scope.row.customized,
                                    expression: "scope.row.customized"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    scope.row.asmblAccFlag ||
                                    !scope.row.customizable
                                },
                                domProps: {
                                  checked: Array.isArray(scope.row.customized)
                                    ? _vm._i(scope.row.customized, null) > -1
                                    : scope.row.customized
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = scope.row.customized,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            scope.row,
                                            "customized",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            scope.row,
                                            "customized",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(scope.row, "customized", $$c)
                                    }
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "60px",
                        prop: "unit",
                        label: "单位"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "100px",
                        prop: "price",
                        label: "统一含税价(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "contractGoodsList." +
                                      scope.$index +
                                      ".price"
                                  }
                                },
                                [
                                  _vm.checkActionPerm("view_item_price")
                                    ? _c("el-input", {
                                        attrs: { maxlength: 9, type: "text" },
                                        on: {
                                          change: function($event) {
                                            _vm.goodsAmountOrQuantityChange(
                                              scope.row,
                                              scope.$index,
                                              "price"
                                            )
                                          }
                                        },
                                        model: {
                                          value: scope.row.price,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "price", $$v)
                                          },
                                          expression: "scope.row.price"
                                        }
                                      })
                                    : _c("el-input", {
                                        attrs: {
                                          disabled: "",
                                          type: "text",
                                          value: "没有权限"
                                        }
                                      })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "right", width: "80", label: "税率(%)" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.checkActionPerm("view_item_price")
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.taxRate))
                                  ])
                                : _c("span", [_vm._v("没有权限")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "80",
                        prop: "taxOffset",
                        label: "购置可抵税"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.taxOffset
                                ? _c("span", [_vm._v("是")])
                                : _c("span", [_vm._v("否")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        width: "100px",
                        prop: "ntxPrice",
                        label: "未税价(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.checkActionPerm("view_item_price")
                                ? _c("div", [
                                    scope.row.ntxPrice != null
                                      ? _c("span", [
                                          _vm._v(_vm._s(scope.row.ntxPrice))
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ])
                                : _c("div", [_c("span", [_vm._v("没有权限")])])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "100px",
                        prop: "bizFormNames",
                        label: "经营业态"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return _vm._l(scope.row.bizFormNameList, function(
                              bizFormName,
                              index
                            ) {
                              return scope.row.bizFormNameList != null &&
                                scope.row.bizFormNameList.length > 0
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "swb-tags swb-tags-success mr5"
                                      },
                                      [_vm._v(_vm._s(bizFormName))]
                                    )
                                  ])
                                : _vm._e()
                            })
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "90",
                        label: "启用区域价格"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.checkActionPerm("view_item_price")
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: scope.row.bizAreaFlag,
                                        expression: "scope.row.bizAreaFlag"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        scope.row.bizAreaFlag
                                      )
                                        ? _vm._i(scope.row.bizAreaFlag, null) >
                                          -1
                                        : scope.row.bizAreaFlag
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = scope.row.bizAreaFlag,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  scope.row,
                                                  "bizAreaFlag",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  scope.row,
                                                  "bizAreaFlag",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              scope.row,
                                              "bizAreaFlag",
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          _vm.bizAreaFlagChange(scope.$index)
                                        }
                                      ]
                                    }
                                  })
                                : _c("span", [_vm._v("没有权限")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.contract.kindId == 0
                      ? _c("el-table-column", {
                          attrs: {
                            align: "right",
                            width: "100px",
                            prop: "amount",
                            label: "含税小计(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.checkActionPerm("view_item_price")
                                    ? _c("div", [
                                        scope.row.amount != null
                                          ? _c("span", [
                                              _vm._v(_vm._s(scope.row.amount))
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ])
                                    : _c("div", [
                                        _c("span", [_vm._v("没有权限")])
                                      ])
                                ]
                              }
                            }
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        width: "90px",
                        prop: "wrntPeriod",
                        label: "质保期(月)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "contractGoodsList." +
                                      scope.$index +
                                      ".wrntPeriod",
                                    rules: {
                                      validator: _vm.inputWrntPeriod,
                                      trigger: "blur"
                                    }
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { type: "text" },
                                    model: {
                                      value: scope.row.wrntPeriod,
                                      callback: function($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "wrntPeriod",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "scope.row.wrntPeriod"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "150px",
                        prop: "desc",
                        label: "说明"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "contractGoodsList." +
                                      scope.$index +
                                      ".desc"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: scope.row.desc,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "desc", $$v)
                                      },
                                      expression: "scope.row.desc"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      staticClass: "fixed",
                      attrs: {
                        align: "left",
                        width: "250",
                        label: "操作",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.removeGoods(scope.$index)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              ),
                              _vm._v(" "),
                              _vm.checkActionPerm("view_item_price") &&
                              scope.row.bizAreaFlag
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.bizAreaOption(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("经营区域价格")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.setBizForm(scope.row, scope.$index)
                                    }
                                  }
                                },
                                [_vm._v("设置经营业态")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAssetInfo
              ? _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.contract.contractGoodsList,
                      border: "",
                      "tooltip-effect": "dark",
                      maxHeight: "500"
                    },
                    on: { "selection-change": _vm.handleSelectionChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        width: "40",
                        align: "center",
                        fixed: "left"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      { attrs: { align: "center", label: "资产信息" } },
                      [
                        _c("el-table-column", {
                          staticStyle: { position: "relative" },
                          attrs: {
                            width: "180",
                            align: "left",
                            prop: "assetDefNo",
                            label: "定义编码",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.assetDefId != null &&
                                  scope.row.assetDefId != -1
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "ellipsis",
                                          staticStyle: {
                                            "padding-right": "5px",
                                            display: "inline-block",
                                            "line-height": "1"
                                          }
                                        },
                                        [_vm._v(_vm._s(scope.row.assetDefNo))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.assetDefId == null ||
                                  scope.row.assetDefId == -1
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.selectDevcDef(
                                                scope.row,
                                                scope.$index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("选择")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.skuId > 0 &&
                                  (scope.row.assetDefId == null ||
                                    scope.row.assetDefId == -1) &&
                                  !_vm.needAudit
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "swb-btn-link",
                                          on: {
                                            click: function($event) {
                                              _vm.saveDevcDef(
                                                scope.row,
                                                scope.$index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("生成定义")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      staticStyle: {
                                        position: "absolute",
                                        right: "2px"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.clearDevcDef(
                                            scope.row,
                                            scope.$index,
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("清除")]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "devcName",
                            label: "名称",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "devcCatName",
                            label: "分类",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "100px",
                            prop: "devcBrandName",
                            label: "品牌",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "devcModel",
                            label: "型号",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "devcFixedSpec",
                            label: "规格",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "60px",
                            prop: "devcUnit",
                            label: "单位"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-table-column",
                      { attrs: { align: "center", label: "商品信息" } },
                      [
                        _c("el-table-column", {
                          staticStyle: { position: "relative" },
                          attrs: {
                            width: "180",
                            align: "left",
                            prop: "name",
                            label: "名称",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  scope.row.name != null && scope.row.name != ""
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "ellipsis",
                                          staticStyle: {
                                            "padding-right": "30px",
                                            display: "inline-block",
                                            width: "100%",
                                            "line-height": "1"
                                          }
                                        },
                                        [_vm._v(_vm._s(scope.row.name))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      staticStyle: {
                                        position: "absolute",
                                        right: "2px"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.selectAdoptedDevice(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [
                                      scope.row.name == null ||
                                      scope.row.name == ""
                                        ? _c("span", [_vm._v("选择")])
                                        : _c("span", [_vm._v("更换")])
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "catName",
                            label: "分类",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            width: "100px",
                            prop: "brandName",
                            label: "品牌",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "model",
                            label: "型号",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "fixedSpec",
                            label: "规格",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "60px",
                            prop: "unit",
                            label: "单位"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.contract.kindId == 0
                      ? _c("el-table-column", {
                          attrs: {
                            align: "center",
                            width: "80px",
                            prop: "quantity",
                            label: "数量"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "contractGoodsList." +
                                          scope.$index +
                                          ".quantity"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          maxlength: 6,
                                          disabled: scope.row.bizAreaFlag,
                                          type: "text"
                                        },
                                        on: {
                                          change: function($event) {
                                            _vm.goodsAmountOrQuantityChange(
                                              scope.row,
                                              scope.$index,
                                              "quantity"
                                            )
                                          }
                                        },
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "quantity",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "scope.row.quantity"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "100",
                        label: "是否可定制"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: scope.row.customized,
                                    expression: "scope.row.customized"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  disabled:
                                    scope.row.asmblAccFlag ||
                                    !scope.row.customizable
                                },
                                domProps: {
                                  checked: Array.isArray(scope.row.customized)
                                    ? _vm._i(scope.row.customized, null) > -1
                                    : scope.row.customized
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = scope.row.customized,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            scope.row,
                                            "customized",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            scope.row,
                                            "customized",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(scope.row, "customized", $$c)
                                    }
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "100px",
                        prop: "price",
                        label: "统一含税价(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "contractGoodsList." +
                                      scope.$index +
                                      ".price"
                                  }
                                },
                                [
                                  _vm.checkActionPerm("view_item_price")
                                    ? _c("el-input", {
                                        attrs: { maxlength: 9, type: "text" },
                                        on: {
                                          change: function($event) {
                                            _vm.goodsAmountOrQuantityChange(
                                              scope.row,
                                              scope.$index,
                                              "price"
                                            )
                                          }
                                        },
                                        model: {
                                          value: scope.row.price,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "price", $$v)
                                          },
                                          expression: "scope.row.price"
                                        }
                                      })
                                    : _c("el-input", {
                                        attrs: {
                                          disabled: "",
                                          type: "text",
                                          value: "没有权限"
                                        }
                                      })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { align: "right", width: "80", label: "税率(%)" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.checkActionPerm("view_item_price")
                                ? _c("span", [
                                    _vm._v(_vm._s(scope.row.taxRate))
                                  ])
                                : _c("span", [_vm._v("没有权限")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "80",
                        prop: "taxOffset",
                        label: "购置可抵税"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.taxOffset
                                ? _c("span", [_vm._v("是")])
                                : _c("span", [_vm._v("否")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        width: "100px",
                        prop: "ntxPrice",
                        label: "未税价(元)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.checkActionPerm("view_item_price")
                                ? _c("div", [
                                    scope.row.ntxPrice != null
                                      ? _c("span", [
                                          _vm._v(_vm._s(scope.row.ntxPrice))
                                        ])
                                      : _c("span", [_vm._v("0.00")])
                                  ])
                                : _c("div", [_c("span", [_vm._v("没有权限")])])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "100px",
                        prop: "bizFormNames",
                        label: "经营业态"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return _vm._l(scope.row.bizFormNameList, function(
                              bizFormName,
                              index
                            ) {
                              return scope.row.bizFormNameList != null &&
                                scope.row.bizFormNameList.length > 0
                                ? _c("div", [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "swb-tags swb-tags-success mr5"
                                      },
                                      [_vm._v(_vm._s(bizFormName))]
                                    )
                                  ])
                                : _vm._e()
                            })
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "90",
                        label: "启用区域价格"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.checkActionPerm("view_item_price")
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: scope.row.bizAreaFlag,
                                        expression: "scope.row.bizAreaFlag"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        scope.row.bizAreaFlag
                                      )
                                        ? _vm._i(scope.row.bizAreaFlag, null) >
                                          -1
                                        : scope.row.bizAreaFlag
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = scope.row.bizAreaFlag,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  scope.row,
                                                  "bizAreaFlag",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  scope.row,
                                                  "bizAreaFlag",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              scope.row,
                                              "bizAreaFlag",
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          _vm.bizAreaFlagChange(scope.$index)
                                        }
                                      ]
                                    }
                                  })
                                : _c("span", [_vm._v("没有权限")])
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _vm.contract.kindId == 0
                      ? _c("el-table-column", {
                          attrs: {
                            align: "right",
                            width: "100px",
                            prop: "amount",
                            label: "含税小计(元)"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm.checkActionPerm("view_item_price")
                                    ? _c("div", [
                                        scope.row.amount != null
                                          ? _c("span", [
                                              _vm._v(_vm._s(scope.row.amount))
                                            ])
                                          : _c("span", [_vm._v("0.00")])
                                      ])
                                    : _c("div", [
                                        _c("span", [_vm._v("没有权限")])
                                      ])
                                ]
                              }
                            }
                          ])
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "right",
                        width: "90px",
                        prop: "wrntPeriod",
                        label: "质保期(月)"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.skuId != null && scope.row.skuId != -1
                                ? _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "contractGoodsList." +
                                          scope.$index +
                                          ".wrntPeriod",
                                        rules: {
                                          validator: _vm.inputWrntPeriod,
                                          trigger: "blur"
                                        }
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "text" },
                                        model: {
                                          value: scope.row.wrntPeriod,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "wrntPeriod",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "scope.row.wrntPeriod"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "contractGoodsList." +
                                          scope.$index +
                                          ".wrntPeriod"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { type: "text" },
                                        model: {
                                          value: scope.row.wrntPeriod,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "wrntPeriod",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "scope.row.wrntPeriod"
                                        }
                                      })
                                    ],
                                    1
                                  )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        width: "60",
                        prop: "asmblAccFlag",
                        label: "组装件"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "contractGoodsList." +
                                      scope.$index +
                                      ".asmblAccFlag"
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: scope.row.asmblAccFlag,
                                        expression: "scope.row.asmblAccFlag"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        scope.row.asmblAccFlag
                                      )
                                        ? _vm._i(scope.row.asmblAccFlag, null) >
                                          -1
                                        : scope.row.asmblAccFlag
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = scope.row.asmblAccFlag,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  scope.row,
                                                  "asmblAccFlag",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  scope.row,
                                                  "asmblAccFlag",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              scope.row,
                                              "asmblAccFlag",
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          _vm.setAsmblAcc(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      ]
                                    }
                                  })
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        align: "left",
                        width: "150px",
                        prop: "desc",
                        label: "说明"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop:
                                      "contractGoodsList." +
                                      scope.$index +
                                      ".desc"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { type: "textarea" },
                                    model: {
                                      value: scope.row.desc,
                                      callback: function($$v) {
                                        _vm.$set(scope.row, "desc", $$v)
                                      },
                                      expression: "scope.row.desc"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      staticClass: "fixed",
                      attrs: {
                        align: "left",
                        width: "250",
                        label: "操作",
                        "show-overflow-tooltip": ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.removeGoods(scope.$index)
                                    }
                                  }
                                },
                                [_vm._v("移除")]
                              ),
                              _vm._v(" "),
                              _vm.checkActionPerm("view_item_price") &&
                              scope.row.bizAreaFlag
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "swb-btn-link",
                                      on: {
                                        click: function($event) {
                                          _vm.bizAreaOption(
                                            scope.row,
                                            scope.$index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("经营区域价格")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.setBizForm(scope.row, scope.$index)
                                    }
                                  }
                                },
                                [_vm._v("设置经营业态")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.contract.kindId != null && _vm.contract.kindId == 0
      ? _c("div", { staticClass: "simple-form flex col-5" }, [
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(9),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _vm.checkActionPerm("view_total_price")
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.contract.estmtAmount,
                        expression: "contract.estmtAmount",
                        modifiers: { number: true }
                      }
                    ],
                    staticStyle: {
                      border: "1px solid #DDDDDD",
                      width: "100px",
                      height: "30px"
                    },
                    attrs: { disabled: "" },
                    domProps: { value: _vm.contract.estmtAmount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.contract,
                          "estmtAmount",
                          _vm._n($event.target.value)
                        )
                      },
                      blur: function($event) {
                        _vm.$forceUpdate()
                      }
                    }
                  })
                : _c("input", {
                    staticStyle: {
                      border: "1px solid #DDDDDD",
                      width: "65px",
                      height: "30px"
                    },
                    attrs: { disabled: "", value: "没有权限" }
                  }),
              _c("span", [_vm._v("元")])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _vm._m(10),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.contract.estmtGoodsCount,
                    expression: "contract.estmtGoodsCount",
                    modifiers: { number: true }
                  }
                ],
                staticStyle: {
                  border: "1px solid #DDDDDD",
                  width: "65px",
                  height: "30px"
                },
                attrs: { disabled: true },
                domProps: { value: _vm.contract.estmtGoodsCount },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.contract,
                      "estmtGoodsCount",
                      _vm._n($event.target.value)
                    )
                  },
                  blur: function($event) {
                    _vm.$forceUpdate()
                  }
                }
              }),
              _c("span", [_vm._v("件")])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("合同信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("启用区域价格")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("是否自动结算")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("结算周期(每月x日)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("发票类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票抬头")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("发票内容标签")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("纳税人识别号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("商品信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计合同总额")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("预计商品总数量")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99906938", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99906938","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractModify.vue
// module id = 3239
// module chunks = 0